import React,{useState} from 'react'
import { useQuery } from 'react-query'
import { fetchAllMembers } from '../connections/requests';
import { Button, Card, Container, Table } from '@mantine/core';
import ActivityBadge from './component/ActivityBadge';
import { useNavigate } from 'react-router-dom';




export default function RenewalTracking() {

    const memberQuery = useQuery(["members"],fetchAllMembers);
    const list = useNavigate()
    const [renewalList,setRenewalList] = useState([""]);

    function getRenewalList(){
       // setRenewalList(memberQuery.data.filter(m=> m.active))
        window.open("mailto:?bcc="+getEmail(memberQuery.data.filter(m=> m.active === "active")), '_blank')
       // console.log(getEmail(memberQuery.data.filter(m=> m.active)))
    }
    function getEmail(members){
        let emailString = "";
        if(members.length === 1) return members[0]?.email;
        for(let i = 0;i<members.length;i++){
            if(members[i]?.email) 
            emailString += members[i]?.email+" ;";
        }
        return emailString;
    
    }
    function RenewalTable(){
        
        const rows = memberQuery.data.map(r => <tr><td>{`${r?.nom} , ${r?.prenom}`}</td><td><ActivityBadge state={r?.active} dateOfMembership={r?.dateOfMembership} /></td></tr>);
        
        return(
                <Container>
                    <Card>
                        <Button onClick={()=>getRenewalList()}>Liste de renouvellements</Button>
                        <Table>
                            <thead>Liste des renouvellements</thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </Table>
                    </Card>
                </Container>
            )       
        }

    return memberQuery.status === "success" ?
    <RenewalTable/>
    :
    <div>Loading</div>
}
